import { forwardRef } from "react";
import { cssModule, mergeProps } from "../../shared";
import { StyleProvider, useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { jsx as _jsx } from "react/jsx-runtime";
export const FieldMessageDefaultElement = "div";
export function getValidationProps(validationState) {
  const isValid = validationState === "valid";
  const isError = validationState === "invalid";
  return {
    isError,
    isHelp: !isValid && !isError,
    isValid
  };
}
export const FieldMessage = /*#__PURE__*/forwardRef(({
  as = FieldMessageDefaultElement,
  children,
  fluid,
  tone,
  ...rest
}, ref) => {
  const fluidValue = useResponsiveValue(fluid);
  return /*#__PURE__*/_jsx(Text, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-field-message", tone, fluidValue && "fluid"),
      ref
    }),
    children: /*#__PURE__*/_jsx(StyleProvider, {
      value: {
        "html-a": {
          color: "inherit"
        },
        "html-ol": {
          color: "inherit"
        },
        "html-p": {
          color: "inherit"
        },
        "html-ul": {
          color: "inherit"
        },
        icon: {
          size: "sm"
        },
        link: {
          color: "inherit"
        },
        p: {
          color: "inherit"
        },
        text: {
          color: "inherit"
        }
      },
      children: children
    })
  });
});